export function StarRating({ stars }) {
  return (
    <div className="flex text-yellow-400 mb-3 text-sm">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`fa ${
            i < Math.floor(stars)
              ? 'fa-star'
              : stars % 1 !== 0 && i === Math.floor(stars)
                ? 'fa-star-half-o'
                : 'fa-star-o'
          }`}
        />
      ))}
    </div>
  );
}
